
import React, { PropTypes } from 'react';
import classnames from 'classnames';

import ArticlePreview from './ArticlePreview';
import ArticleImage from './ArticleImage';
import './style.scss';
import Button from 'components/Button';
import Link from 'components/Link';

const Article = props => {
  const className = classnames('Article', {'is-featured': props.isFeatured, 'in-feed': props.inFeed});
  const { imageUrl, largeImageUrl, excerpt, showsReadMoreAndComments = true, isTitleOnTop, ...otherProps } = props;

  const image = <ArticleImage minWidthForLargeImage={768} url={imageUrl} largeUrl={largeImageUrl} />;
  const imageOrLink = props.shouldOpenProfileFromImage ? <Link to={props.articleUrl}>{image}</Link> : image;

  const preview = (
    <ArticlePreview {...otherProps} showsComments={showsReadMoreAndComments}>
      {(() => {
        if(!isTitleOnTop) {
          return (
            <div>
              <p className="excerpt">{excerpt}</p>
              {showsReadMoreAndComments && <Button isSmall isYellow to={props.articleUrl}>{__('members.magazine.readMore')}</Button>}
            </div>
          );
        }
      })()}
    </ArticlePreview>
  );

  if(isTitleOnTop) {
    return (
      <div className={className}>
        {preview}
        {imageOrLink}
      </div>
    );
  }

  return (
    <div className={className}>
      {imageOrLink}
      {preview}
    </div>
  );
};

Article.propTypes = {
  isFeatured: PropTypes.bool,
  inFeed: PropTypes.bool,
  excerpt: PropTypes.string,
  imageUrl: PropTypes.string,
  largeImageUrl: PropTypes.string,
  articleUrl: PropTypes.string,
  isTitleOnTop: PropTypes.bool,
  showsReadMoreAndComments: PropTypes.bool,
  shouldOpenProfileFromImage: PropTypes.bool
};

export default Article;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/ArticleOuter/Article/index.js
 **/